import Breadcrumbs from "@components/Breadcrumbs";

const ProductBreadcrumbs = ({ breadcrumbs, sku }) => {
  const parsedBreadcrumbs = breadcrumbs && breadcrumbs.slice(0, -1);
  return (
    <div className="flex flex-row items-center pt-[4px]">
      {parsedBreadcrumbs && (
        <Breadcrumbs breadcrumbs={parsedBreadcrumbs} isPDP />
      )}

      <p className="text-sm lg:pt-3 pb-3 lg:mb-6 flex-none">
        Cod produs: <span data-test="PRODUCT_SKU">{sku}</span>
      </p>
    </div>
  );
};

export default ProductBreadcrumbs;
